export const createCustomSelectStyle = (customStyle) => (originalStyle) => ({
  ...originalStyle,
  ...customStyle,
});
